var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{staticClass:"py-8 mb-8",attrs:{"icon":"exclamation-triangle","msg-title":"Nothing to see here, you need to sync and authorize at least one marketplace.","buttonInternalUrl":"/user/account","buttonLabel":"Go to settings"}})}
var staticRenderFns = []

export { render, staticRenderFns }